import { useId } from 'react'
import { Props_SnippetQuotesCarousel } from './QuotesCarousel.props'
import { Legacy_CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, A11y } from 'swiper/modules'
import SwiperControls, { swiperNavigationOptions } from '../Shared/SwiperControls/SwiperControls'

const classBase: string = 'snippet-quotes-carousel'

export const SnippetQuotesCarousel = (props: Props_SnippetQuotesCarousel) => {
    const id = useId()
    const { heading, repeatable_entry } = props

    const uniqueId = useId().replace(/[^a-zA-Z0-9-_]/g, '')
    const carouselId = `snippet-quotes-carousel-${uniqueId}`

    const classHeadingVisibility: string = heading.visibility.value ? `${classBase}__heading--${heading.visibility.value}` : ''

    return (
        <section className="snippet-quotes-carousel">
            <div className={`snippet-quotes-carousel__container`}>
                <h2 className={`snippet-quotes-carousel__heading ${classHeadingVisibility}`}>{ heading.content.value }</h2>
                <div className="snippet-quotes-carousel__container-entries">
                    <Swiper
                        modules={[Navigation, Pagination, A11y]}
                        spaceBetween={40}
                        slidesPerView={1}
                        freeMode={true}
                        watchOverflow={true}
                        watchSlidesProgress={true}
                        grabCursor={true}
                        navigation={{
                            ...swiperNavigationOptions,
                            prevEl: `.swiper-navigation__button-prev-${carouselId}`,
                            nextEl: `.swiper-navigation__button-next-${carouselId}`,
                        }}
                        breakpoints={{
                            1200: {
                                slidesPerView: 2,
                            }
                        }}
                        className="snippet-quotes-carousel__swiper"
                    >
                        { repeatable_entry.map((entry, index: number) => (
                            <SwiperSlide key={`snippet-quotes-carousel__entry-${id}-${index}`}>
                                <div id={id} key={`snippet-quotes-carousel__entry-${id}-${index}`} className="snippet-quotes-carousel__entry">
                                    <div className="snippet-quotes-carousel__entry-content-container">
                                        <div className="snippet-quotes-carousel__entry-quote-container">
                                            { entry.author?.value && <div className="snippet-quotes-carousel__entry-author">{ entry.author.value }</div> }
                                            { entry.position?.value && <div className="snippet-quotes-carousel__entry-position">{ entry.position.value }</div> }
                                        </div>
                                        { entry.content?.value && <div className="snippet-quotes-carousel__entry-content">{ Legacy_CompileMarkdown(entry.content.value) }</div> }
                                        { entry.linkText?.value && entry.linkHref?.value && (
                                            <a
                                                href={entry.linkHref.value}
                                                className="snippet-quotes-carousel__entry-link"
                                                target={entry.linkTarget?.value ? '_blank' : '_self'}
                                                rel={entry.linkTarget?.value ? 'noopener noreferrer' : ''}
                                            >
                                                { entry.linkText.value }
                                            </a>
                                        )}
                                    </div>
                                    { entry.image?.value && (
                                        <figure className="snippet-quotes-carousel__entry-media-container">
                                            <img
                                                className="snippet-quotes-carousel__entry-image"
                                                loading="lazy"
                                                height={375}
                                                width={200}
                                                src={entry.image.value}
                                                alt={entry.alt?.value ? entry.alt.value : ''}
                                            />
                                        </figure>
                                    )}
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <SwiperControls 
                        id={carouselId}
                        showNavigationPrev={true}
                        showNavigationNext={true}
                        showPagination={false}
                        className="snippet-quotes-carousel__swiper-controls"
                    />
                </div>
            </div>
        </section>
    )
}

export default SnippetQuotesCarousel